export default function defaultMiddleware({next}) {
  return next();
}